import { useDraggable } from "@dnd-kit/core";
import { Badge, BadgeProps, Flex } from "@mantine/core";
import styled from "styled-components";
import { theme } from "../../theme";
import { ClockIcon } from "@heroicons/react/24/outline";

const DraggableEmployee = ({
  id,
  name,
  contract,
}: {
  id: string;
  name: string;
  contract: any;
}) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
    });

  const colors = [
    {
      background: "#ECFDF3",
      color: theme.colors.alert.green,
    },
    {
      background: "#FFFAEB",
      color: theme.colors.alert.orange,
    },
    {
      background: "#FEF3F2",
      color: theme.colors.alert.red,
    },
  ];

  return (
    <Wrapper
      $isDragging={isDragging}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
    >
      <Avatar bg={"#EEF2FF"} miw={'44px'} mih="44px" circle>
        <span>{name[0]}</span>
      </Avatar>
      <Flex direction={"column"} gap={4}>
        <EmployeeName>{name}</EmployeeName>
        <StyledBadge
          $bg={colors[contract?.status]?.background}
          $color={colors[contract?.status]?.color}
        >
          <ClockIcon color={colors[contract?.status]?.color} height={12} />
          <div
            style={{
              fontSize: "12px",
            }}
          >
            {contract?.value}
          </div>
        </StyledBadge>
      </Flex>
    </Wrapper>
  );
};

export default DraggableEmployee;

const Wrapper = styled.div<{ $isDragging?: boolean }>`
  padding: 15px 10px;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};
  cursor: grab;
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
`;

const Avatar = styled(Badge)<BadgeProps>`
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: #21005d;
    font-weight: 500;
    font-size: 17.6px;
    line-height: 26.4px;
    letter-spacing: 0.17px;
  }
`;

const EmployeeName = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #111827;
`;

const StyledBadge = styled.div<{ $bg: any; $color: any }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  width: 67px;
  gap: 4px;
  height: 20px;
  width: max-content;
  border-radius: 6px;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
`;
